export default __webpack_public_path__ + "static/media/SAHIL.ef7fe645.jpeg";